var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    fixed: _vm.broadcastVodInfo.bcScheduleSysId && !_vm.broadcastVodInfo.pipMode,
    native: _vm.isNative,
    notch: _vm.isNotch,
    aosApp: _vm.isAos,
    iosApp: _vm.isIosApp,
    isBtmNavHidden: !_vm.btmNav,
    isMobile: _vm.isMobile,
    isBlack : _vm.isBlack,
    demo : this.$route.name !== 'Home' 
  },attrs:{"id":"app"}},[(_vm.broadcastVodInfo.vodPlaying && _vm.broadcastVodInfo.type === 'vod')?_c('PastVod',{ref:"pipBox",class:{
        magnet: _vm.magnetClass
      },style:({
        top: _vm.broadcastVodInfo.top + 'px',
        right: _vm.broadcastVodInfo.right + 'px'
      }),attrs:{"broadcastVodInfo":_vm.broadcastVodInfo}}):_vm._e(),(_vm.broadcastVodInfo.vodPlaying && _vm.broadcastVodInfo.type === 'live')?_c('LivePlayer',{ref:"pipBox",class:{
        magnet: _vm.magnetClass
      },style:({
        top: _vm.broadcastVodInfo.top + 'px',
        right: _vm.broadcastVodInfo.right + 'px'
      }),attrs:{"broadcastVodInfo":_vm.broadcastVodInfo}}):_vm._e(),(_vm.ready)?_c('router-view',{class:{
        fixed:
          (_vm.popVisible && !_vm.popCon && _vm.isMobileWeb) ||
          (_vm.broadcastVodInfo.vodPlaying && !_vm.broadcastVodInfo.pipMode)
      }}):_vm._e(),(_vm.btmNav)?_c('bottom-navigation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }